import { createSlice } from '@reduxjs/toolkit'

const orgSlice = createSlice({
	name: 'org',
	initialState: {
		orgDetails: null,
		orgRole: null,
	},
	reducers: {
		setOrgDetails: (state, action) => {
			state.orgDetails = action.payload
		},
		setOrgRole: (state, action) => {
			state.orgRole = action.payload
		},
		setUserPositions: (state, action) => {
			state.userPositions = action.payload
		},
		clearOrgState: (state) => {
			state.orgDetails = null
			state.orgRole = null
			state.userPositions = null
		},
	},
})

export const { setOrgDetails, setOrgRole, setUserPositions, clearOrgState } =
	orgSlice.actions

export default orgSlice.reducer
